var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editAbout"},[_c('div',{staticClass:"notAva"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._v("暂无相关文档")])])}]

export { render, staticRenderFns }